import { fetchData } from './helpers/fetchData';
import { showAforoDialog } from './helpers/swalAlerts';

const bonusBookingFunctions = () => {
    const content_bonus = document.querySelector('.content_bonus');
    if (!content_bonus) return;

    const data_ubicacion = content_bonus.getAttribute('data-type-booking');

    // Función para cambiar el color de fondo del bonus_container según el estado del checkbox
    const updateBonusContainerColor = (checkbox) => {
        const bonus_container = checkbox.parentElement;
        if (checkbox.checked) {
            bonus_container.style.backgroundColor = '#ccdfff';
            //añadirle la clase active
            bonus_container.classList.add('active');
        } else {
            bonus_container.style.backgroundColor = '';
            //removerle la clase active
            bonus_container.classList.remove('active');
        }
    };

        // Función para dibujar la caja de selección
        const drawSelectionBox = (startX, startY, currentX, currentY) => {
            let selectionBox = document.querySelector('.selection-box');
            if (!selectionBox) {
                selectionBox = document.createElement('div');
                selectionBox.classList.add('selection-box');
                selectionBox.style.position = 'absolute';
                selectionBox.style.border = '2px dashed rgba(0, 123, 255, 0.7)';
                selectionBox.style.backgroundColor = 'rgba(0, 123, 255, 0.1)';
                selectionBox.style.zIndex = '9999';
                document.body.appendChild(selectionBox);
            }
    
            const width = Math.abs(currentX - startX);
            const height = Math.abs(currentY - startY);
            const left = Math.min(currentX, startX);
            const top = Math.min(currentY, startY);
    
            selectionBox.style.width = `${width}px`;
            selectionBox.style.height = `${height}px`;
            selectionBox.style.left = `${left}px`;
            selectionBox.style.top = `${top}px`;
    
            return selectionBox;
        };
    
        // Eliminar la caja de selección
        const removeSelectionBox = () => {
            const selectionBox = document.querySelector('.selection-box');
            if (selectionBox) {
                document.body.removeChild(selectionBox);
            }
        };

    // Función que maneja la selección de checkboxes arrastrando sobre los contenedores
    // const handleDragSelection = () => {
    //     let isDragging = false;
    //     let startContainer = null;
    //     const selectedContainers = new Set();

    //     // Función para seleccionar/deseleccionar el checkbox dentro del contenedor
    //     const toggleCheckboxInContainer = (container, shouldCheck) => {
    //         const checkbox = container.querySelector('input[type="checkbox"]');
    //         if (checkbox && !checkbox.disabled) {
    //             checkbox.checked = shouldCheck;
    //             updateBonusContainerColor(checkbox);
    //         }
    //     };

    //     // Manejador del evento mousedown
    //     const handleMouseDown = (e) => {
    //         // Si el clic es directamente sobre el checkbox, no activamos la lógica de arrastre
    //         if (e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
    //             return;
    //         }

    //         const container = e.target.closest('.bonus_container');
    //         if (container) {
    //             isDragging = true;
    //             startContainer = container;
    //             selectedContainers.clear();
    //             selectedContainers.add(startContainer);

    //             toggleCheckboxInContainer(startContainer, true); // Marcar checkbox al iniciar arrastre

    //             // Evita seleccionar el texto al arrastrar
    //             e.preventDefault();
    //         }
    //     };

    //     // Manejador del evento mouseup
    //     const handleMouseUp = () => {
    //         if (isDragging) {
    //             isDragging = false;
    //             startContainer = null;
    //         }
    //     };

    //     // Manejador del evento mousemove
    //     const handleMouseMove = (e) => {
    //         if (!isDragging) return;

    //         const containers = content_bonus.querySelectorAll('.bonus_container');
    //         containers.forEach((container) => {
    //             const rect = container.getBoundingClientRect();
    //             const inBounds = e.clientY > rect.top && e.clientY < rect.bottom;
    //             if (inBounds && !selectedContainers.has(container)) {
    //                 selectedContainers.add(container);
    //                 toggleCheckboxInContainer(container, true); // Marcar checkbox al pasar sobre el contenedor
    //             }
    //         });
    //     };

    //     // Event listeners para la selección arrastrando sobre contenedores
    //     content_bonus.addEventListener('mousedown', handleMouseDown);
    //     window.addEventListener('mouseup', handleMouseUp);
    //     window.addEventListener('mousemove', handleMouseMove);
    // };

        // Función que maneja la selección de checkboxes arrastrando sobre los contenedores con visualización del área de arrastre
        const handleDragSelection = () => {
            let isDragging = false;
            let startX = 0;
            let startY = 0;
            const selectedContainers = new Set();
    
            // Función para seleccionar/deseleccionar el checkbox dentro del contenedor
            const toggleCheckboxInContainer = (container, shouldCheck) => {
                const checkbox = container.querySelector('input[type="checkbox"]');
                if (checkbox && !checkbox.disabled) {
                    checkbox.checked = shouldCheck;
                    updateBonusContainerColor(checkbox);
                }
            };
    
            // Manejador del evento mousedown
            const handleMouseDown = (e) => {
                // Si el clic es directamente sobre el checkbox, no activamos la lógica de arrastre
                if (e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
                    return;
                }
    
                const container = e.target.closest('.bonus_container');
                if (container) {
                    isDragging = true;
                    startX = e.clientX;
                    startY = e.clientY;
    
                    selectedContainers.clear();
                    selectedContainers.add(container);
    
                    toggleCheckboxInContainer(container, true); // Marcar checkbox al iniciar arrastre
    
                    // Crear la caja de selección
                    drawSelectionBox(startX, startY, startX, startY);
    
                    // Evita seleccionar el texto al arrastrar
                    e.preventDefault();
                }
            };
    
            // Manejador del evento mouseup
            const handleMouseUp = () => {
                if (isDragging) {
                    isDragging = false;
                    removeSelectionBox();
                }
            };
    
            // Manejador del evento mousemove
            const handleMouseMove = (e) => {
                if (!isDragging) return;
    
                const currentX = e.clientX;
                const currentY = e.clientY;
    
                // Actualizar la caja de selección a medida que el ratón se mueve
                drawSelectionBox(startX, startY, currentX, currentY);
    
                const containers = content_bonus.querySelectorAll('.bonus_container');
                containers.forEach((container) => {
                    const rect = container.getBoundingClientRect();
                    const inBounds = rect.top < currentY && rect.bottom > currentY &&
                                     rect.left < currentX && rect.right > currentX;
    
                    if (inBounds && !selectedContainers.has(container)) {
                        selectedContainers.add(container);
                        toggleCheckboxInContainer(container, true); // Marcar checkbox al pasar sobre el contenedor
                    }
                });
            };
    
            // Event listeners para la selección arrastrando sobre contenedores
            content_bonus.addEventListener('mousedown', handleMouseDown);
            window.addEventListener('mouseup', handleMouseUp);
            window.addEventListener('mousemove', handleMouseMove);
        };

    // Aplica el color inicial a los checkboxes seleccionados cuando la página carga
    const applyInitialStyles = () => {
        const checkboxes = content_bonus.querySelectorAll( 'input[type="checkbox"]' );
        checkboxes.forEach((checkbox) => {
            updateBonusContainerColor(checkbox); // Aplica el color inicial
        });
    };

    // Cambia el color cuando los checkboxes cambian de estado
    const changeColorOnCheckboxChange = () => {
        const checkboxes = content_bonus.querySelectorAll( 'input[type="checkbox"]' );
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', function () {
                updateBonusContainerColor(this); // Cambia el color cuando cambia el estado
            });
        });
    };

    // Lógica para preguntar y confirmar si añadir o quitar bonificación
    const callServiceCheckbox = () => {
        const checkboxes = Array.from(content_bonus.querySelectorAll('input[type="checkbox"]'));
        const btnSendBonus = document.getElementById('btn_send_bonus');
        if (!btnSendBonus) return;

        const initialStates = new Map(checkboxes.map((checkbox) => [checkbox.id, checkbox.checked]));
        let saving = false;

        btnSendBonus.addEventListener('click', async () => {
            if (saving) return;
            const changed = checkboxes.filter((checkbox) => checkbox.checked !== initialStates.get(checkbox.id));

            if (!changed.length) {
                await showAforoDialog({
                    title: 'No hay cambios para guardar',
                    text: 'Modifica las bonificaciones de los aforos y pulsa Guardar bonificaciones.',
                    confirmButtonText: 'Entendido',
                });
                return;
            }

            const result = await showAforoDialog({
                title: '¿Guardar bonificaciones?',
                text: 'Se actualizarán las bonificaciones de los aforos que modificaste.',
                showCancelButton: true,
                confirmButtonText: 'Guardar',
                cancelButtonText: 'Cancelar',
            });
            if (!result.isConfirmed) return;

            saving = true;
            btnSendBonus.disabled = true;
            try {
                // Wait for every request before reporting errors: some changes may succeed.
                const results = await Promise.allSettled(changed.map(async (checkbox) => {
                    const response = await fetchData(`${window.location.origin}/aforo/put-bonus/${data_ubicacion}/${checkbox.id}`);
                    if (typeof response?.status !== 'boolean') {
                        throw new Error('No se pudo guardar la bonificación.');
                    }
                    return response;
                }));
                if (results.some((item) => item.status === 'rejected')) {
                    await showAforoDialog({
                        title: 'No se pudieron guardar todas las bonificaciones',
                        text: 'Algunos cambios podrían haberse guardado. Recarga la página para comprobar su estado.',
                        confirmButtonText: 'Recargar',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    window.location.reload();
                    return;
                }

                changed.forEach((checkbox) => initialStates.set(checkbox.id, checkbox.checked));
                await showAforoDialog({
                    title: 'Bonificaciones guardadas',
                    text: 'Se actualizaron las bonificaciones de los aforos.',
                    timer: 1600,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                window.location.reload();
            } finally {
                saving = false;
                btnSendBonus.disabled = false;
            }
        });
    };

    // Ejecutar las funciones necesarias al cargar la página
    applyInitialStyles();       // Aplicar colores iniciales
    changeColorOnCheckboxChange(); // Cambiar colores cuando se seleccionan/desmarcan
    callServiceCheckbox();      // Confirmar bonificaciones
    handleDragSelection();      // Selección arrastrando
};

export default bonusBookingFunctions;